import LanguageEditForm from "./language-edit-form";

export default LanguageEditForm;
